import { render, staticRenderFns } from "./MbCustomCoding.vue?vue&type=template&id=37906e34&scoped=true&"
import script from "./MbCustomCoding.vue?vue&type=script&lang=js&"
export * from "./MbCustomCoding.vue?vue&type=script&lang=js&"
import style0 from "./MbCustomCoding.vue?vue&type=style&index=0&id=37906e34&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37906e34",
  null
  
)

export default component.exports